<template>
  <div class="h-100">
    <main role="main" class="h-100">

      <CommonMasterMapping ref="common-master-mapping" :mapping-no="mappingNo"/>
    </main>
  </div>
</template>

<script>
import CommonMasterMapping from '../custom-components/CommonMasterMapping'
export default {
  components: { CommonMasterMapping },
  data() {
    return {
      mappingNo: 'item'
    }
  },
  computed: {},
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/components/mappings/ItemMapping.vue